module.exports = __webpack_public_path__ + "static/media/baseball.f633aadd.svg";